import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, Row, Col } from 'antd';
import './styles.css';

const ImportSummary = ({ visible, close, importSummary }) => {
  const { newClasses, updatedClasses } = importSummary;
  console.log(importSummary);
  return (
    <Modal
      visible={visible}
      width="80%"
      footer={false}
      className="import-summary">
      <Row className="titleRow">
        <h1>Class Import Summary</h1>
        <div onClick={() => close()} className="dismiss-btn">
          Dismiss
        </div>
      </Row>
      {newClasses && newClasses.length > 0 && (
        <div>
          <div className="title">New Classes ({newClasses.length})</div>
          <Row className="imported-class header">
            <Col xs={4}>Class name</Col>
            <Col xs={4}>Teacher</Col>
            <Col xs={4}>Subject Group</Col>
            <Col xs={4}>Subject</Col>
            <Col xs={6}>Students</Col>
            <Col xs={2}>Grade</Col>
          </Row>
           
          {newClasses.map(item => (
            <Row className="imported-class">
              <Col xs={4}>{item.name}</Col>
              <Col xs={4}>{item.teacherNames && item.teacherNames.join(', ')}</Col>
              <Col xs={4}>{item.subject_category}</Col>
              <Col xs={4}>{item.subject_name}</Col>
              <Col xs={6}>{item.studentNames && item.studentNames.join(', ')}</Col>
              <Col xs={2}>{item.grade}</Col>
            </Row>
          ))}
        </div>
      )}
      {updatedClasses && updatedClasses.length > 0 && (
        <div>
          <div className="title">Updated Classes ({updatedClasses.length})</div>
          <Row className="imported-class header">
            <Col xs={4}>Class name</Col>
            <Col xs={20}>Students</Col>
          </Row>
           
          {updatedClasses.map(item => (
            <Row className="imported-class">
              <Col xs={4}>{item.name}</Col>
              <Col style={{ display: 'flex' }} xs={10}>
                <div className="from">FROM </div>
                {item.prevStudents && item.prevStudents.join(', ')}
              </Col>
              <Col style={{ display: 'flex' }} xs={10}>
                <div className="to">TO </div> {item.studentNames && item.studentNames.join(', ')}
              </Col>
            </Row>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default ImportSummary;



// WEBPACK FOOTER //
// ./src/components/ImportSummary/index.js